import i18n from '@/locales';
import { createApp } from 'vue';
import PromotionsBrowsing from '@/components/PromotionsBrowsing.vue';

// Créer l'app Vue de base à partir de son constructeur
const app = createApp({});

// Ajouter les plugins/extensions globales à l'application
app.use(i18n);

// Ajouter le composant qui devra être reconnu par l'application
app.component('PromotionsBrowsing', PromotionsBrowsing);

// Monter l'application sur un élément qui lui sera dédié dans le gabarit Razor
app.mount('#promotionsBrowsingApp');